

const Contact = () => {
    return (
        <div>
            <h1>Contact Us</h1>
            <form>
                <input type="text" placeholder="name"/>
                <input type="text" name="" id="" placeholder="message" />
                <button type="submit">Submit</button>
            </form>
        </div>
    )
}
export default Contact;